// extracted by mini-css-extract-plugin
module.exports = {"header":"MinimalHeader_header__7Dz_F"};